export default __webpack_public_path__ + "static/media/placeholder-image.453c0dfd.png";